import { render, staticRenderFns } from "./entries.vue?vue&type=template&id=3bcadc3b&scoped=true"
import script from "./entries.vue?vue&type=script&lang=js"
export * from "./entries.vue?vue&type=script&lang=js"
import style0 from "./entries.vue?vue&type=style&index=0&id=3bcadc3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcadc3b",
  null
  
)

export default component.exports